<template>
  <table class="border-separate" style="border-spacing: 0 0.75rem">
    <slot />
  </table>
</template>
